import { api } from "@/lib/api";
import type { WsRole } from "@/features/session/types";
import type { Member, Workspace } from "./types";

export const workspacesApi = {
  list: () => api.get<Workspace[]>("/workspaces"),
  create: (name: string) => api.post<Workspace>("/workspaces", { name }),
  remove: (wsid: string) => api.delete(`/workspaces/${wsid}`),
  members: (wsid: string) => api.get<Member[]>(`/workspaces/${wsid}/members`),
  addMember: (wsid: string, email: string, role: WsRole) =>
    api.post<Member>(`/workspaces/${wsid}/members`, { email, role }),
  setRole: (wsid: string, sub: string, role: WsRole) =>
    api.patch<Member>(`/grants/${sub}/${wsid}`, { role }),
  removeMember: (wsid: string, sub: string) => api.delete(`/workspaces/${wsid}/members/${sub}`),
};

export const workspaceKeys = {
  all: ["workspaces"] as const,
  list: () => [...workspaceKeys.all, "list"] as const,
  members: (wsid: string) => [...workspaceKeys.all, "members", wsid] as const,
};
